// extracted by mini-css-extract-plugin
module.exports = {"component":"Dialog_component_2fsHM","content":"Dialog_content_1f2tW"};